export default {"src":"/_next/static/media/picto-women-hover.d112bba5.svg","height":27,"width":20,"blurWidth":0,"blurHeight":0};